import * as DeviceIcons from '@scaleaq/sui-icons/react/device';
import * as Icons from '@scaleaq/sui-icons/react/icons';
import * as ProductIcons from '@scaleaq/sui-icons/react/products';
import * as sui_colors from '@scaleaq/sui-tokens/colors';
import * as palette from '@scaleaq/sui-tokens/palette';
import * as sui_responsive from '@scaleaq/sui-tokens/responsive';

export const colors = {
  ...sui_colors,
  palette,
};

export const responsive = {
  ...sui_responsive,
};

export const Icon = {
  ...DeviceIcons,
  ...Icons,
  ...ProductIcons,
};
